<template>
  <v-navigation-drawer
    v-model="searchNavigation"
    class="search-navigation !wd-fixed !wd-top-0 !wd-h-full wd-w-full"
    width="0"
    temporary
    permanent
    location="right"
    touchless
  >
    <v-toolbar class="wd-px-5 wd-pt-3 wd-w-full wd-h-full wd-pb-1" height="64" color="white" absolute flat>
      <v-btn class="prev-page-btn mr-3" min-width="32" width="32" height="32" variant="text" @click="setSearchNavigation(false)">
        <funnow-icon class="wd-w-5" max-width="20" :image-path="'chevron-left.svg'" />
      </v-btn>

      <v-form v-if="searchNavigation" class="search-form" @submit.prevent="doSearch({ isEnter: true })">
        <v-text-field
          v-model="inputKeyword"
          class="search-input wd-h-11 wd-w-full"
          :placeholder="placeholder"
          color="orange50"
          autofocus
          variant="outlined"
          density="compact"
          hide-details
        >
          <template #append-inner>
            <v-btn class="clear-btn pa-1" min-width="24" width="24" height="24" elevation="0" variant="text" @click="clearSearchKeyword">
              <funnow-icon max-width="16" :image-path="'remove-icon_gray.svg'" />
            </v-btn>
          </template>
        </v-text-field>
      </v-form>
    </v-toolbar>

    <div class="search-navigation__content">
      <search-content-card
        ref="searchContentCard"
        :popular-keywords="popularKeywords"
        :history-key-words="historyKeyWords"
        @change-keyword="onClickKeyword"
      />
    </div>
  </v-navigation-drawer>
</template>

<script>
import SearchContentCard from '@/components/search/search-content-card'
import FunnowIcon from '@/components/icons/funnow-icon'

export default {
  name: 'SearchNavigation',
  components: {
    SearchContentCard,
    FunnowIcon,
  },
  props: {
    searchKeyword: { type: String, default: '' },
    popularKeywords: { type: Array, default: () => [] },
    historyKeyWords: { type: Array, default: () => [] },
    placeholder: { type: String, default: '' },
  },
  emits: ['submitKeyword'],
  data() {
    return {
      inputKeyword: this.searchKeyword || '',
    }
  },
  computed: {
    searchNavigation: {
      get() {
        return this.$store.state.searchNavigation
      },
      set(val) {
        this.setSearchNavigation(val)
      },
    },
  },
  watch: {
    searchKeyword(newWord) {
      this.inputKeyword = newWord || ''
    },
  },
  methods: {
    setSearchNavigation(state) {
      this.$store.dispatch('setSearchNavigation', state)
    },
    onClickKeyword({ keyword, keywordSource }) {
      this.inputKeyword = keyword
      this.doSearch({ keywordSource })
    },
    clearSearchKeyword() {
      this.inputKeyword = ''
      this.doSearch()
    },
    doSearch(options = {}) {
      const { isEnter = false, keywordSource = '' } = options

      if (this.inputKeyword) {
        this.$store.dispatch('search/saveHistorySearchKeyword', this.inputKeyword)
      }
      this.$emit('submitKeyword', {
        keyword: this.inputKeyword,
        keywordSource,
        isEnter,
      })
      this.setSearchNavigation(false)
    },
  },
}
</script>

<style lang="scss" scoped>
.search-navigation {
  z-index: 21;

  .prev-page-btn {
    margin-left: -12px;
  }

  .search-form {
    width: 100%;
  }

  &__content {
    padding: 72px 0 0;
  }
}
</style>
